import React, { PureComponent } from "react";

import { APP_ENV, TTP_EVENT_URL } from "Config";
import SocialContainer from "../Social/SocialContainer";

import styles from "./Event.local.scss";
import classnames from "classnames";
import { getDateLabel } from "Utils";
import _ from "i18n";

export default class EventComponent extends PureComponent {
  render() {
    const { language, event, index } = this.props;

    const { eventDate } = event;
    const passed = new Date().getTime() > new Date(eventDate).getTime();

    const bannerAttr = `urlBanner${language.charAt(0).toUpperCase() +
      language.slice(1)}`;

    const nameAttr = `name${language.charAt(0).toUpperCase() +
      language.slice(1)}`;

    const placeAttr = `place${language.charAt(0).toUpperCase() +
      language.slice(1)}`;

    let place = event[placeAttr];
    if (!place || place.length === 0) {
      const lngs = ["Fr", "En", "Nl"];
      for (let i = 0; i < lngs.length; i++) {
        if (
          lngs[i].toLowerCase() !== language &&
          event[`place${lngs[i]}`] &&
          event[`place${lngs[i]}`].length > 0
        ) {
          place = event[`place${lngs[i]}`];
          break;
        }
      }
    }

    let banner = event[bannerAttr];
    if (!banner || banner.length === 0) {
      const lngs = ["Fr", "En", "Nl"];
      for (let i = 0; i < lngs.length; i++) {
        if (
          lngs[i].toLowerCase() !== language &&
          event[`banner${lngs[i]}`] &&
          event[`banner${lngs[i]}`].length > 0
        ) {
          banner = event[`banner${lngs[i]}`];
          break;
        }
      }
    }

    let desc = "";
    let dotes = "";
    const maxWords = 8;
    if (event[nameAttr]) {
      const splt = event[nameAttr].split(" ");
      const lgt = splt.length;
      desc = splt.splice(0, maxWords).join(" ");
      if (lgt > maxWords) {
        dotes = "...";
      }
    }
    desc += dotes;

    const appEnv = APP_ENV === "rc2" ? "rc" : APP_ENV;

    let evnType = null;
    switch (event.type) {
      case 6:
        evnType = _("Paid");
        break;
      case 7:
        evnType = _("Free");
        break;
      default:
    }

    return (
      <div
        className={classnames(styles.event, index === 0 ? styles.noMargin : "")}
      >
        <div className={styles.eventContent}>
          <div
            className={styles.banner}
            style={{
              backgroundImage: `url(https://s3.tamtam.pro/${appEnv}${banner.replace(
                "eventsFolder",
                "events-folder"
              )})`
            }}
          />
          <div className={styles.actions}>
            <span
              className={evnType && evnType.length > 0 ? styles.eventType : ""}
            >
              {evnType}
            </span>
            <a
              className={classnames(
                styles.btn,
                passed ? styles.expiresBtn : styles.blue
              )}
              href={`${TTP_EVENT_URL}/${language}/events/${event.id}`}
            >
              {_(passed ? "Expired" : "Participate")}
            </a>
          </div>
          <h3>{desc}</h3>
          <ul className={styles.infos}>
            <li>
              <i className="icon icon-calendar" />
              <span>{getDateLabel(eventDate).split(",")[0]}</span>
            </li>
            {event[placeAttr] ? (
              <li>
                <i className="icon icon-location-pin" />
                <p>{event[placeAttr].split("contact")[0]}</p>
              </li>
            ) : null}
          </ul>
          <SocialContainer resource={event} type="EVENT" customStyle={2} />
        </div>
      </div>
    );
  }
}

// Conn



// WEBPACK FOOTER //
// ./src/components/Community/NewCommunity/Event/EventComponent.js